export const environment = {
  production: false,
  APIURL: 'https://e4score-eztrack-api-stage.azurewebsites.net/api/v1/',
  APIURLV2: 'https://e4score-eztrack-api-stage.azurewebsites.net/api/v2/',
  AUTO_REFRESH_TIME_OUT: 300000, //5mint
  AUTO_REFRESH_TIME_OUT_ezSettings: 900000, //15mint
  MapboxAccessToken: 'pk.eyJ1IjoiZTRzY29yZSIsImEiOiJjbXV2YjFvamgxcWlvMnhwdW5hdGd6Z3ZxIn0.altmQBSGVKQb_tbjSdzOXA',
  eztrackIn: "https://ez.e4score.com/login",
  powerYard: "https://poweryard.e4score.com/login",
  expresSra: "https://expressra.e4score.com/",
  contactUs: "https://www.e4score.com/contact-us/",
  learnMore: "https://www.e4score.com/",
  ezportal: "https://ez.e4score.com",
  archiveBlobBaseUrl: "https://e4scoretrackassured.blob.core.windows.net/e4scoretrackassured/",
};